"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _date = require("@ha/date");

var _constants = require("../constants");

var dateFromFilter = function dateFromFilter(startDate) {
  var startDateTS = (0, _date.dateToTimestamp)(new Date(startDate));
  var noStartDateTS = (0, _date.dateToTimestamp)(new Date(_date.NO_START));
  var multiuseStartDateTS = (0, _date.dateToTimestamp)(new Date(_constants.MULTIUSE_START));
  return "(dateFromTS<=" + startDateTS + " OR dateFromTS=" + noStartDateTS + " OR dateFromTS=" + multiuseStartDateTS + ")";
};

var dateToFilter = function dateToFilter(startDate, endDate) {
  var noEndDateTS = (0, _date.dateToTimestamp)(new Date(_date.NO_END));
  var multiuseEndDateTS = (0, _date.dateToTimestamp)(new Date(_constants.MULTIUSE_END)); // if end date is specified then use that, otherwise use the startDate

  var endDateTS = (0, _date.dateToTimestamp)(new Date(endDate || startDate));
  return "(dateToTS>=" + endDateTS + " OR dateToTS=" + noEndDateTS + " OR dateToTS=" + multiuseEndDateTS + ")";
};

var dateTSBuilder = function dateTSBuilder(_a, context) {
  var startDate = _a.startDate,
      endDate = _a.endDate; // no dates specified

  if (!startDate || !(context === null || context === void 0 ? void 0 : context.withNewDateFilter)) {
    return '';
  }

  var dateFrom = dateFromFilter(startDate);
  var dateTo = dateToFilter(startDate, endDate);
  return [dateFrom, dateTo].join(' AND ');
};

var _default = dateTSBuilder;
exports["default"] = _default;